import {Injectable} from '@angular/core';
import {environment} from '@/environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable, of, tap} from 'rxjs';
import {Streamer} from '@/app/core/models/streamer';

const CACHE_TTL_MS = 5 * 60 * 1000;

@Injectable({
	providedIn: 'root'
})
export class StreamService {

	private readonly SERVICE_URI = `${environment.backendUrl}/stream`;

	constructor(
		private http: HttpClient
	) {}

	getStreamers(): Observable<Streamer[]> {
		return this.http.get<Streamer[]>(`${this.SERVICE_URI}`);
	}

}
